"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitiveMetrics = void 0;
const pipes_1 = require("@neurosity/pipes");
const constants_1 = require("./constants");
const d3 = __importStar(require("d3-array"));
const nChannels = constants_1.MUSE_EEG_CHANNELS.length - 1;
class CognitiveMetrics {
    constructor(props) {
        this.calm = [];
        this.focus = [];
        this.engagement = [];
        this.fatigue = [];
        this.$epochs = props.$epochs;
        this.$powers = this.$epochs.pipe(pipes_1.fft({ bins: 256 }), pipes_1.powerByBand());
        this.calmSubscription();
        this.focusSubscription();
        this.engagementSubscription();
        this.fatigueSubscription();
    }
    calmSubscription() {
        let min = 0;
        let max = 0;
        return this.$powers.subscribe((p) => {
            const alphas = p.alpha.slice(0, nChannels); // Remove Aux
            const mean = d3.mean(alphas);
            min = d3.min([mean, min]);
            max = d3.max([mean, max]);
            const score = (mean - min) / (max - min);
            this.calm.push(score);
        });
    }
    focusSubscription() {
        let min = 0;
        let max = 0;
        return this.$powers.subscribe((p) => {
            const betas = p.beta.slice(0, nChannels);
            const thetas = p.theta.slice(0, nChannels);
            const metrics = betas.map((d, i) => d / thetas[i]);
            const mean = d3.mean(metrics);
            min = d3.min([mean, min]);
            max = d3.max([mean, max]);
            const score = (mean - min) / (max - min);
            this.focus.push(score);
        });
    }
    engagementSubscription() {
        let min = 0;
        let max = 0;
        return this.$powers.subscribe((p) => {
            const thetas = p.theta.slice(0, nChannels);
            const alphas = p.alpha.slice(0, nChannels);
            const betas = p.beta.slice(0, nChannels);
            const metrics = betas.map((b, i) => b / (alphas[i] + thetas[i]));
            const mean = d3.mean(metrics);
            min = d3.min([mean, min]);
            max = d3.max([mean, max]);
            const score = (mean - min) / (max - min);
            this.engagement.push(score);
        });
    }
    fatigueSubscription() {
        let min = 0;
        let max = 0;
        return this.$powers.subscribe((p) => {
            const alphas = p.alpha.slice(0, nChannels);
            const thetas = p.theta.slice(0, nChannels);
            const betas = p.beta.slice(0, nChannels);
            const metrics = thetas.map((t, i) => (t + alphas[i]) / betas[i]);
            const mean = d3.mean(metrics);
            min = d3.min([mean, min]);
            max = d3.max([mean, max]);
            const score = (mean - min) / (max - min);
            this.fatigue.push(score);
        });
    }
}
exports.CognitiveMetrics = CognitiveMetrics;
//# sourceMappingURL=cognitive-metrics.js.map